import { render, staticRenderFns } from "./department.children.list.vue?vue&type=template&id=42ed8774&scoped=true&"
import script from "./department.children.list.vue?vue&type=script&lang=js&"
export * from "./department.children.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed8774",
  null
  
)

export default component.exports